import BuyerAuthModalContainer from 'dpl/pet_insurance/components/BuyerAuthModalContainer';
import CoverageExamples from 'dpl/pet_insurance/components/CoverageExamples';
import FigoFeaturesSlider from 'dpl/pet_insurance/components/FigoFeaturesSlider';
import PageAnalytics from 'dpl/pet_insurance/components/PageAnalytics';
import StickyHeader from 'dpl/pet_insurance/components/StickyHeader';
import initReactApp from 'dpl/util/initReactApp';

initReactApp({
  BuyerAuthModalContainer,
  CoverageExamples,
  FigoFeaturesSlider,
  PageAnalytics,
  StickyHeader
});
